<div class="inbox">
  <div class="reports">
    <div class="report_history">
      <div class="rh_outer">
        <div class="rh_in bill_to_pay">
          <div class="detailpanel gridView full-width-content">
            <div class="bookkeeping-grid" #inboxPane [class.has-selection-bar]="isThreeDotsMenuShown && !isProcessingError">
              <div>
                <div class="column-controls">
                </div>

                <!-- Inbox toolbar — the same header card as Bills to Pay: the title
                     opens a picker (status views + saved filters), the active
                     filter sits as a chip in the search field, and the funnel
                     opens the filter panel. -->
                <app-search-filter-toolbar class="inbox-page-toolbar page-toolbar page-toolbar--two-actions" [config]="inboxSearchFilterConfig"
                  [searchText]="inboxSearchText"
                  (searchChanged)="onInboxSearchChanged($event); !$event && onInboxSearchCleared()"
                  [hasPagination]="false" [isMobileDevice]="isMobileDevice" [showMobileExpand]="false"
                  [hasSearchAction]="true">
                  <div class="group-picker" toolbarHeading>
                    <button type="button" class="group-picker__trigger" (click)="toggleViewMenu($event)"
                      aria-haspopup="true" [attr.aria-expanded]="viewMenuOpen">
                      <!-- The title names the view in play, as Bills to Pay's names its group. -->
                      <span class="page-toolbar-title">{{ activeStatusView.name }}</span>
                      <span class="group-picker__summary page-toolbar-subtitle" *ngIf="!loading">
                        {{ documentCountLabel }}
                      </span>
                      <i class="fa" [ngClass]="viewMenuOpen ? 'fa-chevron-up' : 'fa-chevron-down'" aria-hidden="true"></i>
                    </button>

                    <div class="group-picker__menu" *ngIf="viewMenuOpen" role="menu" (click)="$event.stopPropagation()">
                      <div class="group-picker__caption">Show</div>
                      <button type="button" class="group-picker__item" role="menuitem"
                        *ngFor="let view of statusViews"
                        [class.group-picker__item--active]="view.key === activeStatusView.key"
                        (click)="selectStatusView(view.key); closeViewMenu()">
                        <span class="group-picker__icon"><i class="fa" [ngClass]="view.icon"></i></span>
                        <span class="group-picker__text">
                          <span class="group-picker__name">{{ view.name }}</span>
                          <span class="group-picker__blurb">{{ view.blurb }}</span>
                        </span>
                        <i class="fa fa-check group-picker__check" *ngIf="view.key === activeStatusView.key" aria-hidden="true"></i>
                      </button>

                      <ng-container *ngIf="savedFilterCards.length">
                        <div class="group-picker__divider"></div>
                        <div class="group-picker__caption">Saved filters</div>
                        <button type="button" class="group-picker__item" role="menuitem"
                          *ngFor="let card of savedFilterCards; trackBy: trackCardById"
                          [class.group-picker__item--active]="card.active" [title]="card.rule"
                          (click)="applySavedInboxFilter(card.filter); closeViewMenu()">
                          <span class="group-picker__icon"><i class="fa" [ngClass]="card.icon"></i></span>
                          <span class="group-picker__text">
                            <span class="group-picker__name">{{ card.name }}</span>
                            <span class="group-picker__blurb">{{ card.blurb }}</span>
                          </span>
                          <i class="fa fa-check group-picker__check" *ngIf="card.active" aria-hidden="true"></i>
                        </button>
                      </ng-container>

                      <div class="group-picker__divider"></div>
                      <button type="button" class="group-picker__item group-picker__item--new" role="menuitem"
                        (click)="openNewInboxFilter(); closeViewMenu()" title="Build a filter and save it">
                        <span class="group-picker__icon group-picker__icon--new"><i class="fa fa-plus"></i></span>
                        <span class="group-picker__name">New filter</span>
                      </button>
                    </div>
                  </div>

                  <!-- The filter narrowing the list, inside the search field as on
                       Bills to Pay. Click it to edit, × to clear. -->
                  <div class="active-group-bar" searchFilterChip *ngIf="isFilterShown || hasActiveUnsavedFilters">
                    <button type="button" class="active-group-bar__summary" (click)="editCurrentFilter()"
                      title="Edit this filter">
                      <i class="fa fa-filter active-group-bar__icon"></i>
                      <span class="active-group-bar__text">
                        <strong>{{ activeFilterName }}</strong><span *ngIf="activeFilterRule"> &middot; {{ activeFilterRule }}</span>
                      </span>
                    </button>
                    <button type="button" class="active-group-bar__clear" (click)="clearAllFilters()"
                      title="Clear this filter" aria-label="Clear this filter">&times;</button>
                  </div>

                  <!-- Columns and filters, docked at the right end of the search field. -->
                  <div searchAction class="page-toolbar-search-actions">
                    <app-column-picker [columns]="columnPickerOptions" [isVisible]="isColumnVisibleFn"
                      (toggled)="setColumnVisible($event.key, $event.visible)"></app-column-picker>
                    <button type="button" class="page-toolbar-search-action"
                      (click)="toggleFilterSidebar()" title="Filters"
                      [class.page-toolbar-search-action--active]="isFilterShown || hasActiveUnsavedFilters">
                      <i class="fa fa-filter"></i>
                    </button>
                  </div>
                </app-search-filter-toolbar>

                <ng-container>
                  <!-- SD-1235: the Workflows-style skeleton, the same card and header as the table below. -->
                  <app-list-skeleton *ngIf="(isInProcessingTab || isProcessedTab || isCombinedTab) && loading"
                    class="inbox-skeleton" [columns]="showSubmitterColumn ? skeletonColumnsWithSubmitter : skeletonColumns">
                  </app-list-skeleton>
                  <app-table class="sd-list-card" [class.sd-list-card--joined]="isListEmpty" *ngIf="isInProcessingTab && !loading" [invoices]="filteredInProcessingInvoices"
                    (openInvoice)="openInvoiceOverlay($event)"
                    [status]="statuses.inProcessing" [screenBrakepoint]="screenBrakepoint"
                    [selectedTrackingCategories]="selectedTrackingCategories" [emptyMessage]="emptyMessage"
                    [accounts]="accounts" [showSubmitterColumn]="showSubmitterColumn"
                    (deleteTagEvent)="deleteTag($event)" (rowCheckboxClickEvent)="rowCheckboxClickEvent()"
                    (publishInvoiceEvent)="publishInvoiceFromTable($event)" [canPublish]="canPublish"
                    [columnVisibility]="columnVisibility" (headerFilterApplied)="onHeaderFilterApplied($event)" [currentFilters]="filterParams" [tags]="tagList" [suppliers]="inboxFilterComponent?.suppliers" [submitters]="inboxFilterComponent?.users" [assignedTo]="inboxFilterComponent?.users">
                  </app-table>

                  <app-table class="sd-list-card" [class.sd-list-card--joined]="isListEmpty" *ngIf="isProcessedTab && !loading" [invoices]="filteredProcessedInvoices"
                    (openInvoice)="openInvoiceOverlay($event)"
                    [status]=statuses.processed [maxCount]="isFilterShown ? filteredTotalAmount : processedTotalAmount"
                    [infiniteScroll]="true"
                    [pageSize]="processedPageSize" [page]="processedPage" [pageSizeOptions]="pageSizeOptions"
                    [screenBrakepoint]="screenBrakepoint" [selectedTrackingCategories]="selectedTrackingCategories"
                    [showSubmitterColumn]="showSubmitterColumn"
                    [emptyMessage]="searchText ? 'No records for that search' : isFilterShown ? 'The filter values selected show no records' : 'You\'re all up to date. No documents to process 👍'"
                    (pageSelect)="pageSelect($event)" (pageSizeSelect)="pageSizeSelect($event)"
                    (sortTableEvent)="sortTable($event)" (deleteTagEvent)="deleteTag($event)"
                    (rowCheckboxClickEvent)="rowCheckboxClickEvent()" [columnVisibility]="columnVisibility" (headerFilterApplied)="onHeaderFilterApplied($event)" [currentFilters]="filterParams" [tags]="tagList" [suppliers]="inboxFilterComponent?.suppliers" [submitters]="inboxFilterComponent?.users" [assignedTo]="inboxFilterComponent?.users">
                  </app-table>

                  <app-table class="sd-list-card" [class.sd-list-card--joined]="isListEmpty" *ngIf="isCombinedTab && !loading" [invoices]="filteredCombinedInvoices"
                    (openInvoice)="openInvoiceOverlay($event)"
                    [status]="statuses.combined" [maxCount]="combinedTotalAmount" [infiniteScroll]="true"
                    [pageSize]="combinedPageSize" [page]="combinedPage" [pageSizeOptions]="pageSizeOptions"
                    [screenBrakepoint]="screenBrakepoint" [selectedTrackingCategories]="selectedTrackingCategories"
                    [accounts]="accounts" [showSubmitterColumn]="showSubmitterColumn" [emptyMessage]="emptyMessage"
                    [canPublish]="canPublish"
                    (pageSelect)="combinedPageSelect($event)" (pageSizeSelect)="combinedPageSizeSelect($event)"
                    (sortTableEvent)="combinedSortTable($event)" (deleteTagEvent)="deleteTag($event)"
                    (rowCheckboxClickEvent)="rowCheckboxClickEvent()" (publishInvoiceEvent)="publishInvoiceFromTable($event)"
                    [columnVisibility]="columnVisibility" [currentFilters]="filterParams" [tags]="tagList">
                  </app-table>

                  <app-processing-error *ngIf="isProcessingError"
                    [records]="processingErrorRecords"></app-processing-error>
                </ng-container>

                <!-- Empty state — lives inside the table panel so it's centred
                     under the toolbar, not pushed below the full-height block. -->
                <!-- Framed with the table above it (sd-list-card--joined), so the two read as one card. -->
                <div class="empty-hero inbox-empty-frame" *ngIf="isListEmpty">
                  <div class="empty-hero__art" aria-hidden="true">
                    <div class="empty-hero__doc"></div>
                    <div class="empty-hero__doc empty-hero__doc--back"></div>
                    <div class="empty-hero__plus">+</div>
                  </div>
                  <div class="empty-hero__title">
                    {{ hasAnyBill ? 'Nothing to show here' : 'Upload your first expense' }}
                  </div>
                  <div class="empty-hero__sub">
                    {{ hasAnyBill
                      ? 'Expenses that match the current filter will appear here.'
                      : 'Drop a receipt or forward a PDF to your email inbox — your agent will code it for you.' }}
                  </div>
                  <button type="button" class="empty-hero__cta" [class.empty-hero__cta--secondary]="hasAnyBill" (click)="createExpense()">
                    <svg *ngIf="!hasAnyBill" width="14" height="14" viewBox="0 0 14 14" fill="none"><path d="M7 1v12M1 7h12" stroke="currentColor" stroke-width="2" stroke-linecap="round"/></svg>
                    {{ hasAnyBill ? 'Add another' : 'Upload an expense' }}
                  </button>
                </div>

                <!-- Infinite-scroll sentinel: when this scrolls into view the
                     component fetches & appends the next page of records. -->
                <div #infiniteScrollAnchor class="inbox-load-more">
                  <div class="inbox-load-more__spinner" *ngIf="loadingMore">
                    <span class="inbox-load-more__dot"></span>
                    Loading more…
                  </div>
                </div>
              </div>

              <!-- SD-1235: selection actions as a bar fixed across the foot of the list, as on
                   Bills to Pay — was a floating pill of unlabelled icons over the rows. Placed
                   against the list pane's measured left/width (see refreshSelectionBar). -->
              <div class="inbox-selection-bar" *ngIf="!isProcessingError && isThreeDotsMenuShown"
                [style.left.px]="selectionBarLeft" [style.width.px]="selectionBarWidth || null"
                role="toolbar" aria-label="Selected documents">
                <div class="inbox-selection-bar__count">
                  {{ selectedInvoicesCount }} selected &middot; {{ selectedInvoicesTotal | number : '1.2-2' }}
                  <button type="button" class="inbox-selection-bar__clear" (click)="clearSelection()">Clear</button>
                </div>
                <div class="inbox-selection-bar__actions">
                  <button type="button" class="inbox-selection-bar__btn" [matMenuTriggerFor]="menuTag"
                    (click)="showAddTagMenu()" title="Add a tag to every selected document">
                    <i class="fa fa-plus" aria-hidden="true"></i> Add tag
                  </button>
                  <button type="button" class="inbox-selection-bar__btn" (click)="downloadCheckedInvoices()"
                    [disabled]="isDownloadingSelection" title="Download the selected documents">
                    <i class="fa fa-download" aria-hidden="true"></i> {{ isDownloadingSelection ? 'Preparing…' : 'Download' }}
                  </button>
                  <button type="button" class="inbox-selection-bar__btn" [matMenuTriggerFor]="menuExport"
                    (click)="showExportMenu()" title="Download as a spreadsheet">
                    <i class="fa fa-file-excel-o" aria-hidden="true"></i> Export
                  </button>
                  <button type="button" class="inbox-selection-bar__btn inbox-selection-bar__btn--danger"
                    *ngIf="isInProcessingTab" (click)="showDeleteConfirm()" [disabled]="isDeletingSelection"
                    title="Delete the selected documents">
                    <i class="fa fa-trash-o" aria-hidden="true"></i> {{ isDeletingSelection ? 'Deleting…' : 'Delete' }}
                  </button>
                </div>

                <mat-menu #menuTag="matMenu" class="inbox-bulk-menu" (closed)="menuClosed()">
                  <!-- Styled globally (::ng-deep .inbox-bulk-menu): a mat-menu renders in the overlay,
                       outside this component, so its scoped styles never reach it. -->
                  <div class="bulk-tag-menu">
                    <div class="bulk-tag-menu__title">Tag {{ selectedInvoicesCount }} selected</div>
                    <div class="bulk-tag-menu__search">
                      <i class="fa fa-search" aria-hidden="true"></i>
                      <input type="text" placeholder="Search or create a tag" aria-label="Search tags"
                        (click)="$event.stopPropagation()" (keydown)="$event.stopPropagation()" [ngModel]="tagSearchTerm"
                        (ngModelChange)="filterTags($event)" (blur)="clearTagSearchValue()">
                    </div>
                    <div class="bulk-tag-menu__list">
                      <button type="button" class="bulk-tag-menu__item" *ngFor="let tagMenuItem of filteredTagList; trackBy: trackTagById"
                        (click)="addTagToInvoices(tagMenuItem)">
                        <span class="bulk-tag-menu__dot" [style.background]="tagMenuItem.backColor || '#EEF2FF'"></span>
                        <span class="bulk-tag-menu__label">{{ tagMenuItem.tagName }}</span>
                      </button>
                      <div class="bulk-tag-menu__empty" *ngIf="!filteredTagList?.length && !isAddTagMenuItemShown">
                        No tags found
                      </div>
                    </div>
                    <button type="button" class="bulk-tag-menu__new" *ngIf="isAddTagMenuItemShown" (click)="createNewTag()">
                      <i class="fa fa-plus" aria-hidden="true"></i>
                      <span class="bulk-tag-menu__label">Create “{{ tagSearchTerm }}”</span>
                    </button>
                  </div>
                </mat-menu>
                <mat-menu #menuExport="matMenu" class="inbox-bulk-menu" (closed)="menuClosed()">
                  <div class="export-list">
                    <mat-radio-group aria-label="What to export" class="example-radio-group"
                      [(ngModel)]="exportOption" (click)="$event.stopPropagation()">
                      <mat-radio-button class="example-radio-button" [value]="1">
                        Export Selected
                      </mat-radio-button>
                      <mat-radio-button class="example-radio-button" [value]="0">
                        Export All
                      </mat-radio-button>
                    </mat-radio-group>
                    <div class="export-list-item" *ngIf="isExportMenuShown" (click)="exportRecords()">
                      Export
                    </div>
                  </div>
                </mat-menu>
              </div>
            </div>

          </div>
          <div class="detailpanel emailbody-wrap" *ngIf="showDetailPanel"
            [ngStyle]="{'width': showDetailPanel ? '34%' : '0%','height': showDetailPanel ? 'calc(100vh - 85px)' : '0'}">
            <div class="sidenav_in">
              <app-sidebar [isSidebarVisible]=isSidebarVisible [isSettingsSidebar]=isSettingsSidebar
                [isUploadSidebar]=isUploadSidebar (isClosed)="toggleSidebar($event)">
              </app-sidebar>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<app-sidebar [initialFiles]="droppedFiles" [isSidebarVisible]=isSidebarVisible [isSettingsSidebar]=isSettingsSidebar
  [isUploadSidebar]=isUploadSidebar (isClosed)="toggleSidebar($event)">
</app-sidebar>

<!-- Drop target while a file is dragged over the page; letting go opens the upload
     panel with it. Purely visual: the window listeners in the component do the work. -->
<div class="inbox-drop" *ngIf="isFileDragActive" aria-hidden="true">
  <div class="inbox-drop__card">
    <div class="inbox-drop__icon">
      <svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8"
           stroke-linecap="round" stroke-linejoin="round">
        <path d="M12 16V4"/><path d="M7 9l5-5 5 5"/><path d="M4 16v2a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2v-2"/>
      </svg>
    </div>
    <div class="inbox-drop__title">Drop to add an expense</div>
    <div class="inbox-drop__sub">PDF, PNG or JPG &mdash; it opens ready to submit</div>
  </div>
</div>
<!-- Filter panel — Bills to Pay's drawer, with the Inbox's fields. -->
<div [ngClass]="showFilterPanel ? 'sidenav sidenav-show' : 'sidenav'">
  <div class="sidenav_in">
    <div class="form-group">
      <app-inbox-filter [isOpen]="showFilterPanel" [accounts]="accounts" [tags]="tagList"
        [selectedTrackingCategories]="selectedTrackingCategories"
        (applied)="applyInboxFilterCriteria($event)" (saved)="onInboxFilterSaved($event)"
        (deleted)="onInboxFilterDeleted($event)" (closeFilter)="toggleFilterSidebar()">
      </app-inbox-filter>
    </div>
  </div>
</div>

<!-- In-page invoice detail — same split (document preview + form) as the
     editInvoice page, opened over the inbox via the `id` query param. Rendered
     through a CDK overlay (body-level container + block-scroll) so it covers
     the viewport reliably and the table keeps its scroll position behind it.
     The form header carries its own close. -->
<ng-template #invoiceDetailTpl>
  <!-- The dim, as Bills to Pay draws it. Clicking it closes, like the backdrop behind it. -->
  <div class="app-panel-scrim" (click)="closeInvoiceOverlay()" aria-hidden="true"></div>
  <div class="inbox-detail-overlay__panel" [class.no-document]="!overlayHasDocument">
    <app-add-new-invoice-page
      [isEmbedded]="true"
      [invoiceId]="overlayInvoiceId"
      [embeddedEditMode]="overlayEditMode"
      (closed)="closeInvoiceOverlay()"
      (navigateInvoice)="openInvoiceOverlay($event)"
      (hasDocumentChange)="overlayHasDocument = $event"
      (invoicePublished)="removeInvoiceFromInbox($event)"
      (invoiceSaved)="updateInboxRow($event)"
      (onDeleteDocument)="removeInvoiceFromInbox($event)">
    </app-add-new-invoice-page>
  </div>
</ng-template>

<!-- Save Filter Dialog -->
<div class="save-filter-dialog" *ngIf="showSaveFilterDialog">
  <div class="dialog-backdrop" (click)="cancelSaveFilter()"></div>
  <div class="dialog-content">
    <div class="dialog-header">
      <h3>Save Filter</h3>
      <button class="close-btn" (click)="cancelSaveFilter()">×</button>
    </div>
    <div class="dialog-body">
      <div class="form-group">
        <label for="filterNameInput">Filter Name:</label>
        <input id="filterNameInput" type="text" [(ngModel)]="newFilterName" placeholder="Enter filter name"
          class="filter-name-input" (keyup.enter)="confirmSaveFilter()" />
      </div>
    </div>
    <div class="dialog-footer">
      <button class="cancel-btn" (click)="cancelSaveFilter()">Cancel</button>
      <button class="save-btn" (click)="confirmSaveFilter()" [disabled]="!newFilterName || newFilterName.trim() === ''"
        [ngClass]="{'disabled': !newFilterName || newFilterName.trim() === ''}">
        Save Filter
      </button>
    </div>
  </div>
</div>
